import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PreferenceService } from '../../../services/preference.service';
import { TreeNode } from 'primeng/api';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import * as fromFeature from '../../../my-features';
import { RegionService } from 'src/app/services/region.service';
import { CryptoService } from '../../../services/crypto.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-used-device-detail',
  templateUrl: './used-device-detail.component.html',
  styleUrls: ['./used-device-detail.component.css']
})
export class UsedDeviceDetailComponent implements OnInit {
  private componentDestroyed = new Subject();
  licenseUsedDetailTable_cols: any[] = [
    { field: 'Company', header: 'Company', width: '220', class: 'col-nowrap' },
    { field: '', header: 'Used Device', width: '220', class: 'col-nowrap' },
  ];
  licenseUsedDetailList = [];
  datePickStart: Date;
  licenseUsageList: TreeNode[];
  getMspDeviceUsageParam = {
    otp: '',
    RegionId: 0,
    UsageDate: '',
    UnitPrice: 0
  };
  deviceUsageTotal = {
    name: '',
    quantity: 0,
    unitprice: 0,
    amount: 0,
  };
  ReadRegionParam = {
    otp: '',
    MspMainRegionId: 0
  };
  minEndDate: Date;
  maxEndDate: Date;
  constructor( private _location: Location, public preferenceService: PreferenceService, private regionService: RegionService,
    private store: Store<fromStore.State>, private route: ActivatedRoute, private cryptoService: CryptoService ) {

    const regionId = parseInt(this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('id')))
    this.getMspDeviceUsageParam = {
      ...this.getMspDeviceUsageParam,
      RegionId: regionId,
    };
    this.getDefaultDate();
    const param = {
      otp: '',
      RegionId: regionId
    };
    this.ReadRegionParam = {
      ...this.ReadRegionParam,
      MspMainRegionId: regionId,
    };
    this.store.dispatch(new fromFeature.GetMspRegions({ ...this.ReadRegionParam }));
    this.store.dispatch(new fromFeature.ReadMspDeviceUsageList(param));

    // Get Device Usage List
    this.store.select(fromStore.getMspDeviceUsageList(regionId)).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res !== undefined && res.deviceUsage !== undefined && res.deviceUsage.length > 0 && res.region_dic.length > 0) {
        this.licenseUsageList = [];
        for (const i in res.deviceUsage) {
          const item = res.deviceUsage[i];
          if (item !== undefined && item.data !== undefined && item.name == undefined) {
            this.licenseUsageList.push({
              data: item.data,
              expanded: item.expanded,
              children: item.children
            });
          }
          break;
        }
        this.deviceUsageTotal.quantity = res.TotalDeviceUsage;
      }
    });
  }

  ngOnInit() {
    this.licenseUsageList = [];
    this.deviceUsageTotal = {
      name: '',
      quantity: 0,
      unitprice: 0,
      amount: 0,
    };
  }

  backClicked() {
    this._location.back();
  }

  reload() {
    this.licenseUsageList = [];
    this.deviceUsageTotal = {
      name: '',
      quantity: 0,
      unitprice: 0,
      amount: 0,
    };
    const year = this.datePickStart.getFullYear().toString();
    const month = (this.datePickStart.getMonth() + 1).toString().padStart(2, '0');
    // const date = this.datePickStart.getDate().toString().padStart(2, '0');

    // 當下月份的1號
    const dateStr = `${year}-${month}-01`;
    // const dateStr = `${year}-${month}-${date}`;
    this.getMspDeviceUsageParam = {
      ...this.getMspDeviceUsageParam,
      UsageDate: dateStr,
    };
    // this.store.dispatch(new fromFeature.GetMspRegions(this.ReadRegionParam));
    this.store.dispatch(new fromFeature.ReadMspDeviceUsageList({ ...this.getMspDeviceUsageParam }));
  }

  getDefaultDate() {
    const today = new Date();
    const preDate = new Date(today);
    this.maxEndDate = today;
    this.minEndDate = new Date('2024/01/01');
    this.datePickStart = preDate;
  }

  changeDate(e: any) {
    // console.log(e);
    this.datePickStart = e;
    this.reload();
  }

  ngOnDestroy(): void {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }
}
